// extracted by mini-css-extract-plugin
export default {"paginacion":"Paginacion_paginacion__NhbLP","activo":"Paginacion_activo__Jrw6L"};